export const isDateString = (dateString: string) => {
  return !isNaN(Date.parse(dateString))
}
